import { BaseEntity } from "#sitis/internal/models/concrete/BaseEntity";
import { Product } from "#sitis/internal/controllers/products/models/Product";
export class CheckoutData extends BaseEntity {
  bonusPercent;
  bonusDescriptionPageUrl;
  isBonusesEnabled;
  isPromoCodesEnabled;
  promo;
  phone;
  deliveryHidePrice;
  deliveryHidePricePercent;
  showAcceptRulesCheckbox;
  acceptRulesPageUrl;
  acceptRulesPageUrlText;
  cartTotalDiscounts;
  promotions;
  costRoundMethod;
  payments;
  deliveries;
  cart;
  constructor(data) {
    super(data);
    this.bonusPercent = data.bonus_percent;
    this.bonusDescriptionPageUrl = data.bonus_description_page_url;
    this.isBonusesEnabled = data.is_bonuses_enabled;
    this.isPromoCodesEnabled = data.is_promo_codes_enabled;
    this.promo = data.promo;
    this.phone = data.phone;
    this.deliveryHidePrice = data.delivery_hide_price;
    this.deliveryHidePricePercent = data.delivery_hide_price_percent;
    this.showAcceptRulesCheckbox = data.show_accept_rules_checkbox;
    this.acceptRulesPageUrl = data.accept_rules_page_url;
    this.acceptRulesPageUrlText = data.accept_rules_page_url_text;
    this.cartTotalDiscounts = data?.cart_total_discounts;
    this.promotions = data?.promotions?.map((t) => ({
      bonusType: t?.bonus_type,
      discountType: t?.discount_type,
      discountValue: t?.discount_value,
      id: t?.id,
      label: t?.label,
      minProductsCount: t?.min_products_count,
      minTotal: t?.min_total,
      productsIds: t?.products_id,
      bonusValue: t?.bonus_value,
      title: t?.title
    }));
    this.costRoundMethod = data?.cost_round_method;
    this.payments = [...data?.payments];
    this.deliveries = [...data.deliveries];
    this.cart = {
      availableBonusesValue: data?.cart?.available_bonuses_value,
      discounts: data?.cart?.discounts,
      discountValue: data?.cart?.discount_value,
      incomingBonusesValue: data?.cart?.incoming_bonuses_value,
      itemsInfo: data?.cart?.items_info.map((t) => ({
        discountValue: t?.discount_value,
        discounts: t?.discounts.map((disc) => ({
          name: disc.name,
          percent: disc.percent,
          type: disc.type,
          value: disc.value
        })),
        optionsGroups: t?.optionsGroups.map((opt) => ({
          externalId: opt.external_id,
          name: opt.name,
          isMultiple: opt.is_multiple,
          id: opt.id,
          sort: opt.sort,
          variantGroups: opt.variantGroups,
          variants: opt.variants.map((variant) => ({
            name: variant.name,
            price: variant.price,
            id: variant.id,
            sort: variant.sort,
            depth: variant.depth,
            height: variant.height,
            weight: variant.weight,
            width: variant.width,
            volume: variant.volume,
            seats: variant.seats,
            sku: variant.sku,
            exclusionIds: variant.exclusion_ids,
            externalId: variant.external_id,
            imageId: variant.image_id,
            imagesIds: variant.images_ids,
            isProduct: variant.is_product,
            priceOld: variant.price_old,
            priceOldValue: variant.price_old_value,
            priceType: variant.price_type,
            variantGroupId: variant.variant_group_id,
            priceValue: variant.price_value
          }))
        })),
        product: t.product ? new Product(t.product).toJSON() : null,
        options: t.options,
        incomingBonusesValue: t?.incoming_bonuses_value,
        id: t?.id,
        origin: t?.origin,
        total: t?.total,
        modificationId: t?.modification_id,
        price: t?.price,
        quantity: t?.quantity,
        productId: t?.product_id
      })),
      maxAvailableBonusesDiscountValue: data?.cart?.max_available_bonuses_discount_value,
      maxBonusesDiscountValue: data?.cart?.max_bonuses_discount_value,
      productsCount: data?.cart?.products_count,
      total: data?.cart?.total,
      subtotal: data?.cart?.subtotal,
      itemsCount: data?.cart?.items_count
    };
  }
  toJSON() {
    return this;
  }
}
